<div class="header">
  <h2>Delete Confirmation</h2>
  <p> Do you really want to delete this element?</p>
</div>

<div class="actions">
  <button mat-button type="button" class="btnNegative" mat-dialog-close> No </button>
  <button mat-button type="button" class="btnPositive" mat-dialog-close="{{true}}"> Yes </button>
</div>
